/*============================================================================
  Kaching bundle <-> theme cart bridge

  The full-page Kaching bundle builder (#gbbBundle) adds to the cart with its
  own AJAX request (POST /cart/update.js?app=gbbSdkBundleApp), bypassing the
  theme's product-form.js. As a result the cart-count bubble never updates and
  the cart drawer never opens (you have to refresh).

  Rather than monkey-patch window.fetch (several apps wrap it, so a patch gets
  clobbered), we watch for a click on the bundle's "Add To Cart" button and
  then poll /cart.js until the cart actually changes. On change we run the same
  refresh the regular product page uses:
  cart.renderContents() -> re-renders #cart-icon-bubble (count) + the drawer,
  then open()s it.

  Self-gating: it only opens the drawer when the cart genuinely changes, so
  clicking the button in a non-add state (e.g. "Select Subscription Plan")
  does nothing. Inert on every non-bundle page.
============================================================================*/
(function () {
  var cart = null;

  function getCartSig() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        return c.item_count + '|' + (c.items || []).map(function (i) {
          return i.key + ':' + i.quantity;
        }).join(',');
      })
      .catch(function () { return null; });
  }

  function refreshAndOpen() {
    var ids = cart.getSectionsToRender().map(function (s) { return s.id; });
    fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) { cart.renderContents({ sections: sections }); })
      .catch(function (e) { console.error('[bundle-cart] cart refresh failed', e); });
  }

  // After an add click, watch the cart until it changes, then refresh + open.
  function watchCartThenOpen() {
    getCartSig().then(function (before) {
      var tries = 0;
      (function poll() {
        tries += 1;
        getCartSig().then(function (now) {
          if (now !== null && now !== before) { refreshAndOpen(); return; }
          if (tries < 20) setTimeout(poll, 500); // up to ~10s
        });
      })();
    });
  }

  function activate() {
    cart = document.querySelector('cart-drawer');
    if (!cart || typeof cart.renderContents !== 'function') return;

    // Capture-phase so we see the click before the app handles it.
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.gbbFooterNextButton')) {
        watchCartThenOpen();
      }
    }, true);
  }

  // The bundle SDK injects #gbbBundle asynchronously; wait for it, then activate.
  function waitForBundle() {
    if (document.querySelector('#gbbBundle')) { activate(); return; }
    var obs = new MutationObserver(function () {
      if (document.querySelector('#gbbBundle')) { obs.disconnect(); activate(); }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForBundle);
  } else {
    waitForBundle();
  }
})();
